import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import Tooltip from "canvas-core-react/lib/Tooltip";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { withRouter } from "react-router-dom";
import { getUserByCode } from "../../../../Redux/reducer/users";
import UserProviderRoles from "./providerUsers/usersProviderRoles";
import AddUserForm from "./AddUserForm";
import i18next from "i18next";

import {
  invalidPhoneNumber,
  includeSpecialCharacters,
  invalidPhoneLastCharacter,
} from "../../../utils/functions";

const options = [
  {
    name: "firstName",
    validation: includeSpecialCharacters,
    msg: "includeSpecialCharacters",
  },
  {
    name: "lastName",
    validation: includeSpecialCharacters,
    msg: "includeSpecialCharacters",
  },
  {
    name: "phone",
    validation: invalidPhoneNumber,
    msg: "invalidPhoneNumber",
  },
  {
    name: "phone",
    validation: invalidPhoneLastCharacter,
    msg: "invalidPhoneLastCharacter",
  },
];

export class AddClientUser extends Component {
  constructor(props) {
    super(props);
    var readOnly = true;

    if (props.canEdit === true) {
      // Permisos de escritura
      readOnly = this.props.user.createBy == null ? false : true;
    }

    const {
      user: { status, ...restUser },
    } = props;

    this.state = {
      user: {
        ...restUser,
        status: status === "TRANSITORY" ? "ACTIVE" : status,
      },
      readOnly,
      errors: {},
      submitted: false,
    };
  }

  hasErrors = (provider) => {
    const errors = options.reduce((acc, { name, validation, msg }) => {
      if (validation(provider[name])) {
        if (!acc[name]) acc[name] = i18next.t(`general.formErrors.${msg}`);
      }
      return acc;
    }, {});

    this.setState({ errors, submitted: true });

    return Object.keys(errors).length > 0;
  };

  setRoles = () => {
    if (this.hasErrors(this.state.user)) return;

    this.props.nextStep(this.state.user, this.state.readOnly);
  };

  handlerChange = (event) => {
    event?.persist && event?.persist();
    const { user, submitted } = this.state;
    const { name, value } = event.target;
    user[name] = value;

    if (submitted) this.hasErrors(user);

    this.setState({ user });
  };

  toogleReadOnly = () => {
    const { readOnly } = this.state;
    if (readOnly === true) {
      this.setState({ readOnly: !readOnly });
    }
  };

  pendingData = (attribute) => {
    const { user } = this.state;
    var data = user.recordsTmp !== null ? user.recordsTmp.data : null;
    return (
      data !== null &&
      data[attribute] !== undefined &&
      data[attribute] !== user[attribute] && (
        <div className="flex-element">
          <label className="edited-client-info" htmlFor={attribute}>
            Espacio pendiente de aprobación
          </label>
          <div className="left-flex fix-tooltip">
            <Tooltip
              id="tooltip-id"
              closeButtonLabel="Close Tooltip"
              infoButtonLabel="Info"
              heading={"Pendiente de aprobación"}
            >
              <label
                className="edited-client-info tooltip-color"
                htmlFor={attribute}
              >
                {`De aprobarse el cambio este campo cambiaría su valor de ${user[attribute]} por ${data[attribute]}`}
              </label>
            </Tooltip>
          </div>
        </div>
      )
    );
  };

  getValue = (attribute) => {
    const { user } = this.props;
    var data = user.recordsTmp !== null ? user.recordsTmp.data : null;

    return data !== null &&
      data[attribute] !== undefined &&
      data[attribute] !== user[attribute]
      ? data[attribute]
      : user[attribute];
  };

  enableActionsButton = () => {
    const { user } = this.state;
    return (
      user.identification ||
      (user.firstName !== "" &&
        user.lastName !== "" &&
        user.phone !== "" &&
        user.email !== "")
    );
  };

  render() {
    const { user, readOnly, errors } = this.state;
    const {
      editUser,
      isStatusSelect,
      match: { params },
    } = this.props;

    const disabled =
      !user.identification ||
      !user.firstName ||
      !user.lastName ||
      !user.phone ||
      !user.email;

    return (
      <>
        <div id="add-client-user">
          <h2>
            {editUser
              ? `${i18next.t("clients.users.subtitle")}`
              : `${i18next.t("clients.users.add_user")}`}
          </h2>
          <div className="ref-user flex-element">
            <div>
              <p>
                <b>{i18next.t("clients.users.cod_user")}: </b>
                {user.codUser}
              </p>
              <p>
                <b>{i18next.t("clients.users.reference")}: </b>
                {user.selRefName}
              </p>
            </div>
            {this.props.user.createBy !== null &&
              this.props.canEdit === true && (
                <p
                  className={`left-flex edit-lbl ${!readOnly ? "disable" : ""}`}
                  onClick={this.toogleReadOnly}
                >
                  {i18next.t("clients.users.edit")}
                </p>
              )}
          </div>

          <AddUserForm
            isAddUser
            isStatusSelect={isStatusSelect}
            phone={user.phone}
            email={user.email}
            readOnly={readOnly}
            status={user.status}
            lastName={user.lastName}
            firstName={user.firstName}
            pendingData={this.pendingData}
            handlerChange={this.handlerChange}
            identification={user.identification}
            errors={errors}
          />

          {window.location.pathname ===
          `/bscadministrator/users/${params.providerId}/${params.companyId}/${params.id}/${params.countryCode}/add` ? (
            <UserProviderRoles
              user={this.state.user}
              endStep={this.props.endStep}
              closeStep={this.props.closeStep}
              hasErrors={() => this.hasErrors(this.state.user)}
              disabled={disabled}
            />
          ) : (
            <div className="form-actions clearfix">
              <SecondaryButton
                id={`back-btn`}
                className="btnLimpiar"
                disabled={!this.enableActionsButton()}
                onClick={this.enableActionsButton() && this.props.closeStep}
              >
                {i18next.t("general.buttons.cancel")}
              </SecondaryButton>
              <SecondaryButton
                id={`next-btn`}
                className="btnAgregar"
                disabled={!this.enableActionsButton()}
                onClick={this.enableActionsButton() && this.setRoles}
              >
                {i18next.t("general.buttons.continue")}
              </SecondaryButton>
            </div>
          )}
        </div>
      </>
    );
  }
}

AddClientUser.propTypes = {
  closeStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
};

export const mapStateToProps = (state) => {
  return {
    user: getUserByCode(state),
  };
};

export default withRouter(connect(mapStateToProps, null)(AddClientUser));
